import { render } from "./EmbeddedApp.vue?vue&type=template&id=4a6b6f54&scoped=true"
import script from "./EmbeddedApp.vue?vue&type=script&lang=js"
export * from "./EmbeddedApp.vue?vue&type=script&lang=js"

import "./EmbeddedApp.vue?vue&type=style&index=0&id=4a6b6f54&scoped=true&lang=css"

import exportComponent from "../../SherpaCRM/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6b6f54"]])

export default __exports__